// extracted by mini-css-extract-plugin
export default {"root":"VZycc","animation":"hL8Pn"};